let counter = 0
const form = document.getElementById('bracket-form');
const continue_button = document.getElementById('submit-btn');
let unlock_array = []

const slider = document.querySelector('.bracket-container');
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active-grab');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
});
slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active-grab');
});
slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active-grab');
});
slider.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    bracket_gradient()
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX); //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
});

slider.addEventListener('touchmove', () => {
    bracket_gradient()
})

function hide_show_footer() {
    let site_footer = document.querySelector(".site-footer")
    let top_bar =  document.querySelector(".top-bar")
    let top_page_button = document.querySelector(".top-page-button")
    if (window.innerWidth < 480 || window.innerWidth >= 1880) {
        site_footer.classList.remove("reverse-footer-transition")
        top_bar.classList.remove("reverse-top-footer-transition")
        site_footer.classList.remove("footer-transition")
        top_bar.classList.remove("top-footer-transition")
    } else {
        if ((window.innerHeight + (window.scrollY)) >= (document.body.offsetHeight + 150)) {
            site_footer.classList.add("footer-transition")
            top_bar.classList.add("top-footer-transition")
            site_footer.classList.remove("reverse-footer-transition")
            top_bar.classList.remove("reverse-top-footer-transition")
        } else {
            site_footer.classList.remove("footer-transition")
            top_bar.classList.remove("top-footer-transition")
            site_footer.classList.add("reverse-footer-transition")
            top_bar.classList.add("reverse-top-footer-transition")

        }
    }
    if (window.innerWidth >= 1880) {
        if(window.scrollY > 0) {
            top_page_button.style.display = "block"
        } else {
            top_page_button.style.display = "none"
        }
    } else if (window.innerWidth > 480 || window.innerWidth < 1880) {
        top_page_button.removeAttribute("style")
    }
}

function bracket_gradient() {
    let bracket_container = document.querySelector(".bracket-container")
    let overlay1 = document.querySelector(".overlay")
    let overlay2 = document.querySelector(".overlay-left")
    let bracket_left_scroll = bracket_container.scrollLeft
    let max_scroll = bracket_container.scrollWidth - bracket_container.clientWidth
    let left_bracket_button = document.querySelector(".left-side-bracket")
    let right_bracket_button = document.querySelector(".right-side-bracket")
    if (window.innerWidth > 480) {
        if (bracket_left_scroll === 0) {
            overlay2.style.display = "none"
            overlay1.style.display = "block"
            left_bracket_button.classList.add("highlight-bracket-button")
        } else if (bracket_left_scroll === max_scroll) {
            overlay1.style.display = "none"
            overlay2.style.display = "block"
            right_bracket_button.classList.add("highlight-bracket-button")
        } else if (bracket_left_scroll > 0) {
            overlay2.style.display = "block"
            overlay1.style.display = "block"
            left_bracket_button.classList.remove("highlight-bracket-button")
            right_bracket_button.classList.remove("highlight-bracket-button")
        }
    } else {
        overlay2.removeAttribute("style")
        overlay1.removeAttribute("style")
    }
}

window.onscroll = function(ev) {
   hide_show_footer()
};

bracket_gradient()
hide_show_footer()

function scroll_bar_page(scroll_value, round_id, scroll_value_2) {
    let active_elements = document.querySelectorAll(".active")
    active_elements.forEach((element) => {
        element.classList.remove('active');
    })
    document.getElementById(round_id).classList.add("active")
    document.getElementById("rounds-bar").scrollTo({left: scroll_value_2, behavior: 'smooth'});
    document.getElementById("bracket-container").scrollTo({left: scroll_value, behavior: 'smooth'});
    window.scrollTo({top: 0, behavior: 'smooth'})
}

document.querySelectorAll(".controls").forEach(value => {
    value.addEventListener("click", function(event) {
        if (event.currentTarget.id === "back-btn") {
            counter -= 1
            if (counter < 1) {
                window.location.href = "/"
            }
        } else if (event.currentTarget.id === "back-btn-2") {
            if (counter > 0) {
                counter -= 1
            }
        }

        if (event.currentTarget.id !== "back-btn" && event.currentTarget.id !== "back-btn-2") {
            if (counter === 0) {
                counter += 1
            }
        }

        function add_animation(groups, group_animation, margin_animation, section) {
            for (const group of groups) {
                let elements = document.querySelectorAll(group)
                for (const element of elements) {
                    element.classList.add(group_animation)
                }
            }
            document.getElementById(section).classList.add(margin_animation)
        }
        function remove_animation(groups, group_animation, margin_animation, section) {
            for (const group of groups) {
                let elements = document.querySelectorAll(group)
                for (const element of elements) {
                    element.classList.remove(group_animation)
                }
            }
            document.getElementById(section).classList.remove(margin_animation)
        }
        function add_remove_height_animation(animation_names, remove_animation_names, remove) {
            let bracket_container = document.querySelector(".bracket-container")
            animation_names.forEach(item => {
                bracket_container.classList.add(item)
            })
            if (remove === true) {
                remove_animation_names.forEach(item => {
                    bracket_container.classList.remove(item)
                })
            }
        }

        function reset_selections (groups, reset_words) {
            groups.forEach(element => {
                let selections = document.querySelectorAll(element + " input.value-checkbox")
                    selections.forEach(item => {
                        item.checked = false
                    })
            })
            reset_words.forEach(element2 => {
                let selections_words = document.querySelectorAll(element2 + " label.value-checkbox")
                selections_words.forEach(item => {
                    item.innerHTML = ""
                })
            })
        }

        function remove_values_unlock_array(value) {
            while (unlock_array.length > value) {
                unlock_array.pop()
            }
        }

        function notAllowedCursor() {
            document.getElementById("icon-submit-btn-filled").style.pointerEvents = "none"
            document.getElementById("icon-submit-btn").style.pointerEvents = "none"
            document.querySelector(".icon-submit-btn-container").style.cursor = "not-allowed"
            document.querySelector(".continue-filled-in").style.display = "none"
            document.querySelector(".continue-faded").style.display = "block"
        }

        if (counter === 0 ) {
            // do nothing
        } else if (counter === 1) {
            if (event.currentTarget.id === "back-btn" || event.currentTarget.id === "back-btn-2") {
                notAllowedCursor()
                unlock_array = []
                add_remove_height_animation(["bracket-container-height-transition"], ["bracket-container-height-transition2"], true)
                reset_selections([".groups", ".groups12", ".groups2", ".groups11", ".groups3", ".groups10"], [".groups2", ".groups11", ".groups3", ".groups10"])
                remove_animation([".groups2", ".groups11"], "Animation1", "Animation2", "section11")
                remove_animation([".groups3", ".groups10"], "Animation3", "Animation2", "section10")
                add_animation([".groups2", ".groups11"], "Animation1-reverse", "Animation2-reverse", "section11")
                add_animation([".groups3", ".groups10"], "Animation3-reverse", "Animation2-reverse", "section10")
                scroll_bar_page(0, "round-1", 0)
            } else {
                notAllowedCursor()
                add_remove_height_animation(["bracket-container-height-transition2"])
                document.querySelector(".bracket-container").classList.add("bracket-container-height-transition2")
                add_animation([".groups2", ".groups11"], "Animation1", "Animation2", "section11")
                add_animation([".groups3", ".groups10"], "Animation3", "Animation2", "section10")
                remove_animation([".groups2", ".groups11"], "Animation1-reverse", "Animation2-reverse", "section11")
                remove_animation([".groups3", ".groups10"], "Animation3-reverse", "Animation2-reverse", "section10")
                scroll_bar_page(240, "round-2", 140)
            }
        } else if (counter === 2) {
            if (event.currentTarget.id === "back-btn" || event.currentTarget.id === "back-btn-2") {
                notAllowedCursor()
                remove_values_unlock_array(32)
                add_remove_height_animation(["bracket-container-height-transition2"], ["bracket-container-height-transition3"], true)
                reset_selections([".groups2", ".groups11", ".groups3", ".groups10"], [".groups3", ".groups10", ".groups4", ".groups9"])
                remove_animation([".groups3", ".groups10"], "Animation5", "Animation4", "section10")
                remove_animation([".groups4", ".groups9"], "Animation6", "Animation7", "section9")
                add_animation([".groups3", ".groups10"], "Animation5-reverse", "Animation4-reverse", "section10")
                add_animation([".groups4", ".groups9"], "Animation6-reverse", "Animation7-reverse", "section9")
                scroll_bar_page(240, "round-2", 140)
            } else {
                notAllowedCursor()
                add_remove_height_animation(["bracket-container-height-transition3"], ["bracket-container-height-transition2"], true)
                remove_animation([".groups3", ".groups10"], "Animation3", "Animation2", "section10")
                add_animation([".groups3", ".groups10"], "Animation5", "Animation4", "section10")
                add_animation([".groups4", ".groups9"], "Animation6", "Animation7", "section9")
                remove_animation([".groups3", ".groups10"], "Animation5-reverse", "Animation4-reverse", "section10")
                remove_animation([".groups4", ".groups9"], "Animation6-reverse", "Animation7-reverse", "section9")
                scroll_bar_page(480, "round-3", 280)
            }
        } else if (counter === 3) {
            if (event.currentTarget.id === "back-btn" || event.currentTarget.id === "back-btn-2") {
                add_remove_height_animation(["bracket-container-height-transition3"], ["bracket-container-height-transition4"], true)
                notAllowedCursor()
                remove_values_unlock_array(48)
                reset_selections([".groups3", ".groups10", ".groups4", ".groups9", ".groups5", ".groups8"], [".groups4", ".groups9", ".groups5", ".groups8"])
                remove_animation([".groups4", ".groups9"], "Animation9", "Animation8", "section9")
                remove_animation([".groups5", ".groups8"], "Animation10", "Animation11", "section8")
                add_animation([".groups4", ".groups9"], "Animation9-reverse", "Animation8-reverse", "section9")
                add_animation([".groups5", ".groups8"], "Animation10-reverse", "Animation11-reverse", "section8")
                scroll_bar_page(480, "round-3", 280)
            } else {
                notAllowedCursor()
                add_remove_height_animation(["bracket-container-height-transition4"], ["bracket-container-height-transition3"], true)
                remove_animation([".groups4", ".groups9"], "Animation6", "Animation7", "section9")
                add_animation([".groups4", ".groups9"], "Animation9", "Animation8", "section9")
                add_animation([".groups5", ".groups8"], "Animation10", "Animation11", "section8")
                remove_animation([".groups4", ".groups9"], "Animation9-reverse", "Animation8-reverse", "section9")
                remove_animation([".groups5", ".groups8"], "Animation10-reverse", "Animation11-reverse", "section8")
                scroll_bar_page(720, "round-4", 420)
            }
        } else if (counter === 4) {
            if (event.currentTarget.id === "back-btn" || event.currentTarget.id === "back-btn-2") {
                notAllowedCursor()
                add_remove_height_animation(["bracket-container-height-transition4"], ["bracket-container-height-transition5"], true)
                remove_values_unlock_array(56)
                reset_selections([".groups4", ".groups9", ".groups5", ".groups8", ".groups6", ".groups7"], [".groups5", ".groups8", ".groups6", ".groups7"])
                remove_animation([".groups5", ".groups8"], "Animation12", "Animation13", "section8")
                remove_animation([".groups6", ".groups7"], "Animation14", "Animation15", "section7")
                add_animation([".groups5", ".groups8"], "Animation12-reverse", "Animation13-reverse", "section8")
                add_animation([".groups6", ".groups7"], "Animation14-reverse", "Animation15-reverse", "section7")
                scroll_bar_page(720, "round-4", 420)
            } else {
                notAllowedCursor()
                add_remove_height_animation(["bracket-container-height-transition5"], ["bracket-container-height-transition4"], true)
                remove_animation([".groups5", ".groups8"], "Animation10", "Animation11", "section8")
                add_animation([".groups5", ".groups8"], "Animation12", "Animation13", "section8")
                add_animation([".groups6", ".groups7"], "Animation14", "Animation15", "section7")
                remove_animation([".groups5", ".groups8"], "Animation12-reverse", "Animation13-reverse", "section8")
                remove_animation([".groups6", ".groups7"], "Animation14-reverse", "Animation15-reverse", "section7")
                scroll_bar_page(975, "round-5", 560)
            }
        } else if (counter === 5) {
            notAllowedCursor()
            if (event.currentTarget.id === "back-btn" || event.currentTarget.id === "back-btn-2") {
                remove_values_unlock_array(60)
                reset_selections([".groups5", ".groups8", ".groups6", ".groups7"], [".groups6", ".groups7"])
                remove_animation([".groups6", ".groups7"], "Animation16", "Animation17", "section7")
                add_animation([".groups6", ".groups7"], "Animation16-reverse", "Animation17-reverse", "section7")
                scroll_bar_page(975, "round-5", 560)
            } else {
                notAllowedCursor()
                remove_animation([".groups6", ".groups7"], "Animation14", "Animation15", "section7")
                add_animation([".groups6", ".groups7"], "Animation16", "Animation17", "section7")
                remove_animation([".groups6", ".groups7"], "Animation16-reverse", "Animation17-reverse", "section7")
                scroll_bar_page(1220, "round-6", 700)
            }
        }

        if (event.currentTarget.id !== "back-btn" && event.currentTarget.id !== "back-btn-2") {
            counter += 1
            if (counter > 6) {
                submit();
            }
        }
    })
})


document.querySelectorAll(".bracket-controls").forEach(value => {
    value.addEventListener("click", (event) => {
        let bracket_container = document.querySelector(".bracket-container")
        let max_scroll = bracket_container.scrollWidth - bracket_container.clientWidth
        let overlay1 = document.querySelector(".overlay")
        let overlay2 = document.querySelector(".overlay-left")
        let left_bracket_button = document.querySelector(".left-side-bracket")
        let right_bracket_button = document.querySelector(".right-side-bracket")
        if (event.target.id === "left-bracket") {
            document.getElementById("bracket-container").scrollTo({left: 0, behavior: 'smooth'});
            overlay1.style.display = "block"
            overlay2.style.display = "none"
            left_bracket_button.classList.add('highlight-bracket-button')
            right_bracket_button.classList.remove('highlight-bracket-button')
        } else {
            document.getElementById("bracket-container").scrollTo({left: max_scroll, behavior: 'smooth'});
            overlay1.style.display = "none"
            overlay2.style.display = "block"
            left_bracket_button.classList.remove('highlight-bracket-button')
            right_bracket_button.classList.add('highlight-bracket-button')
        }
    })
})

document.querySelectorAll("label.value-checkbox").forEach(value => {
    value.addEventListener("click", (event) => {
        let id = event.target.id
        let value_word = event.target.innerHTML
        let parentGroupNumber = document.getElementById(id).parentElement.parentElement.className.split(" ")[0].split("-")[1]
        let parent = document.getElementById(id).parentElement.parentElement
        let children = parent.children
        let childrenArray = []
        let check_array = []
        const continue_button = document.getElementById('submit-btn');
        for (let i = 0; i < children.length-1; i++) {
            childrenArray.push(children[i].children[2].id)
        }

        function unlock_next_section() {
            if(unlock_array.length === 32 || unlock_array.length === 48 || unlock_array.length === 56 || unlock_array.length === 60 || unlock_array.length === 62 || unlock_array.length === 63) {
                if(window.innerWidth < 481) {
                    document.querySelector(".icon-submit-btn-container").style.cursor = "pointer"
                    document.querySelector(".continue-filled-in").style.display = "block"
                    document.querySelector(".continue-faded").style.display = "none"
                    document.getElementById("icon-submit-btn").style.pointerEvents = "all"
                    document.getElementById("icon-submit-btn-filled").style.pointerEvents = "all"
                } else {
                    if(unlock_array.length === 63) {
                        continue_button.style.backgroundColor = 'rgb(55,103,63, 1)';
                        continue_button.style.pointerEvents = 'all';
                    }
                }
            }
        }

        function animation_check() {
            if (unlock_array.includes(id)) {
                // do nothing
            } else {
                unlock_array.push(id)
                let opposite_selection = (+id % 2 ? +id + 1 :  +id - 1)
                let index = unlock_array.indexOf(String(opposite_selection))
                if (unlock_array.includes(String(opposite_selection))) {
                    unlock_array.splice(index, 1)
                }
            }
            unlock_next_section()
        }

        function checkBoxes() {
            const child = id === childrenArray[0] ? childrenArray[1] : childrenArray[0]
            if (childrenArray[0] === '63' || childrenArray[0] === '64') {
                let final_selection = document.getElementById("hidden-" + id)
                let alternate_selection = document.getElementById("hidden-" + (id % 2 === 0 ? id - 1 : +id + 1))
                final_selection.nextElementSibling.checked = false
                final_selection.value = +final_selection.value + 1
                alternate_selection.nextElementSibling.checked = false
                alternate_selection.value = +final_selection.value - 1
            } else {
                document.getElementById("checkbox-" + id).checked = false
                document.getElementById("checkbox-" + child).checked = false
                document.querySelector(".bracket-line-" + parentGroupNumber).classList.add("bracket-line-transition")
                transfer_word()
            }
        }
        function transfer_unlock(next_id) {
            next_id.innerHTML = value_word
            let next_id_parent = next_id.parentElement.parentElement.className.split(" ")[0].split("-")[1]
            let next_id_parent_children = document.querySelector(".group-"+ next_id_parent).children
            for (let i = 0; i < next_id_parent_children.length-1; i++) {
                check_array.push(next_id_parent_children[i].children[2].innerHTML)
            }
            if (!check_array.includes("")) {
                //whatever group you checked can have pointer events turned on
                document.querySelector(".bracket-line-" + next_id_parent).classList.add("bracket-line-transition")
                document.querySelectorAll(".group-" + next_id_parent +" .value-container label").forEach(function(element) {
                    element.style.pointerEvents = "all"
                    element.parentElement.cursor = "pointer"
                })
                document.querySelectorAll(".group-" + next_id_parent +" .value-container input").forEach(function(element) {
                    element.style.pointerEvents = "all"
                })
            }
        }
        function transfer_word () {
            const next_id = document.getElementById(+parentGroupNumber + (parentGroupNumber <= 32 ? 32 : 30))
            let selected_label = document.getElementById(id)
            let alternate_label = document.getElementById((id % 2 === 0 ? id - 1 : +id + 1))
            let find_words = document.querySelectorAll("label")
            let counter2 = 1
            let second_section_Array = []
            find_words.forEach(element => {
                if (element.innerHTML === alternate_label.innerHTML) {
                    let element_parent_group = element.parentElement.parentElement.className.split(" ")[0].split("-")[1]
                    let alternate_parent_group = alternate_label.parentElement.parentElement.className.split(" ")[0].split("-")[1]
                    if (id < 63) {
                        if(+element_parent_group > +alternate_parent_group)  {
                            element.innerHTML = selected_label.innerHTML
                            element.previousElementSibling.previousElementSibling.name = selected_label.previousElementSibling.previousElementSibling.name
                            element.previousElementSibling.previousElementSibling.value = +selected_label.previousElementSibling.previousElementSibling.value + counter2
                            counter2 += 1
                        }
                    } else {
                        second_section_Array.push(element)
                    }
                }
                let counter3 = second_section_Array.length - 1
                second_section_Array.forEach(element => {
                    let element_parent_group = element.parentElement.parentElement.className.split(" ")[0].split("-")[1]
                    let alternate_parent_group = alternate_label.parentElement.parentElement.className.split(" ")[0].split("-")[1]
                    if(+element_parent_group < +alternate_parent_group)  {
                        element.innerHTML = selected_label.innerHTML
                        element.previousElementSibling.previousElementSibling.name = selected_label.previousElementSibling.previousElementSibling.name
                        element.previousElementSibling.previousElementSibling.value = +selected_label.previousElementSibling.previousElementSibling.value + counter3
                        counter3 -= 1
                    }
                })
            })
            let current_hidden = document.getElementById("hidden-" + id)
            let alternate_hidden = document.getElementById("hidden-" + (id % 2 === 0 ? id - 1 : +id + 1))
            document.getElementById("hidden-" + (+parentGroupNumber + (parentGroupNumber <= 32 ? 32 : 30))).name = current_hidden.name
            document.getElementById("hidden-" + (+parentGroupNumber + (parentGroupNumber <= 32 ? 32 : 30))).value = +current_hidden.value + 1
            transfer_unlock(next_id)
            current_hidden.setAttribute('disabled', "")
            alternate_hidden.removeAttribute('disabled')
        }
        checkBoxes()
        animation_check()
    })
})

function resetAnimations() {
    for (let i = 1; i <= 18; i++){
        let classReset = document.querySelectorAll('.Animation' + [i])
        let classReset2 = document.querySelectorAll('.Animation' + [i] + '-reverse')
        for (const item of classReset) {
            item.classList.remove("Animation" + [i])
        }
        for (const item2 of classReset2) {
            item2.classList.remove("Animation" + [i] + '-reverse')
        }
    }
}

//WINDOW RESIZE FIX TO UNDO MOBILE TRANSITIONS
bracket_gradient()
window.addEventListener('resize', function(event) {
    hide_show_footer()
    if(window.innerWidth <= 480) {
        resetAnimations()
        document.querySelector(".top-bar").classList.remove("reverse-top-footer-transition")
    } else {
        counter = 1
        document.getElementById("rounds-bar").scrollTo({left: 0, behavior: 'smooth'});
    }
}, true);
// END OF FIX

export const submit = () => form.submit();

export const reset = () => {
    scroll_bar_page(0, "round-1", 0)
    resetAnimations()
    counter = 0
    unlock_array = []
    for (let i = 1; i <= 18; i++){
        let animation_height = document.querySelectorAll('.bracket-container-height-transition' + [i])
        for (const item of animation_height) {
            item.classList.remove("bracket-container-height-transition" + [i])
        }
    }
    document.querySelector(".bracket-container").classList.add("bracket-container-height-transition")
    continue_button.style.backgroundColor = 'rgb(55,103,63, .5)';
    continue_button.style.pointerEvents = 'none';
    document.getElementById("rounds-bar").scrollTo({left: 0, behavior: 'smooth'});
    document.getElementById("bracket-container").scrollTo({left: 0, behavior: 'smooth'});
    document.querySelectorAll('.bracket-lines').forEach(item => {
        item.classList.remove('bracket-line-transition');
    });
    document.querySelectorAll('.bracket-inner .value-container').forEach(item => {
        item.style.cursor = "not-allowed";
        item.querySelector('input.value-checkbox').value = null;
        item.querySelector('input.value-checkbox').style.pointerEvents = "none";
        item.querySelector('input').removeAttribute("disabled")
        item.querySelector('label.value-checkbox').innerHTML = null;
        item.querySelector('label.value-checkbox').style.pointerEvents = "none";
    });
    document.querySelectorAll('.bracket-outer .value-container').forEach(item => {
        item.querySelector('input').removeAttribute("disabled")
    })
    return form.reset();
};

export const random = () => {
    const next = document.querySelector('#icon-submit-btn');
    for (let i = 1; i <= 6; i++) {
        document.querySelectorAll('.section-group-' + i).forEach(section => {
            section.querySelectorAll('.allGroups').forEach(group => {
                [...group.querySelectorAll('label.value-checkbox')]
                    .map(value => ({value, sort: Math.random()}))
                    .sort((a, b) => a.sort - b.sort)
                    .map(({value}) => value)
                    .shift()
                    .click();
            });
            if(window.innerWidth <= 480) {
                next.click();
            }
        });
    }
};




